import type { OrderItem } from './MorningDashboardContextProps';

export enum DASHBOARD_ACTIONS_TYPE {
    set_customize_opened = 'SET_CUSTOMIZE_OPENED',
    load_order = 'LOAD_ORDER',
    swap = 'SWAP',
    confirm_order = 'CONFIRM_ORDER',
    revert_order = 'REVERT_ORDER',
    trigger_refresh = 'TRIGGER_REFRESH',
}


export type DashboardState = {
    isCustomizeOpened: boolean;
    order: OrderItem[];
    savedOrder: OrderItem[];
    refreshKey: number;
};

export type DashboardAction =
    | { type: DASHBOARD_ACTIONS_TYPE.set_customize_opened; payload: boolean }
    | { type: DASHBOARD_ACTIONS_TYPE.load_order; payload: OrderItem[] }
    | { type: DASHBOARD_ACTIONS_TYPE.swap; fromIndex: number; toIndex: number }
    | { type: DASHBOARD_ACTIONS_TYPE.confirm_order }
    | { type: DASHBOARD_ACTIONS_TYPE.revert_order }
    | { type: DASHBOARD_ACTIONS_TYPE.trigger_refresh };

export const initialDashboardState: DashboardState = {
    isCustomizeOpened: false,
    order: [],
    savedOrder: [],
    refreshKey: 0,
};

export const dashboardReducer = (state: DashboardState, action: DashboardAction): DashboardState => {
    switch (action.type) {
        case DASHBOARD_ACTIONS_TYPE.set_customize_opened:
            return { ...state, isCustomizeOpened: action.payload };
        case DASHBOARD_ACTIONS_TYPE.load_order:
            return { ...state, order: action.payload, savedOrder: action.payload };
        case DASHBOARD_ACTIONS_TYPE.swap: {
            if (action.fromIndex === action.toIndex) return state;
            const next = [...state.order];
            const [removed] = next.splice(action.fromIndex, 1);
            next.splice(action.toIndex, 0, removed);
            return { ...state, order: next };
        }
        case DASHBOARD_ACTIONS_TYPE.confirm_order:
            return { ...state, savedOrder: state.order, isCustomizeOpened: false };
        case DASHBOARD_ACTIONS_TYPE.revert_order:
            return { ...state, order: state.savedOrder, isCustomizeOpened: false };
        case DASHBOARD_ACTIONS_TYPE.trigger_refresh:
            return { ...state, refreshKey: state.refreshKey + 1 };
        default:
            return state;
    }
};
